<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <h4>Firstmac PDF Tools</h4>
      <strong>App:</strong> 7006003
    </div>
  </div>
  <div class="row">
    <div class="col-4">
      <fmc-file-upload
          [idv]="7006003"
          [idt]="'v8ApplicationId'"
      ></fmc-file-upload>
    </div>
    <div class="col-4">
      <fmc-file-viewer
          [idv]="7006003"
          [idt]="'v8ApplicationId'"
      ></fmc-file-viewer>
    </div>
    <div class="col-4">
      <fmc-file-selection
          [idv]="7006003"
          [idt]="'v8ApplicationId'"
      ></fmc-file-selection>
    </div>
  </div>
</div>